import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Badge, Card, CardBody, CardHeader, Flex, Heading, Link, Text, VStack } from '@chakra-ui/react';
import { formatCallTime } from '../../utils/callTimezone';
import { callOutcomes, outcomeColor, outcomeDetail, outcomeLabel, outcomeLink } from './callOutcomes';

export const OutcomeBadges = ({ call, lang }) => {
  const items = callOutcomes(call);
  if (!items.length) return <Text fontSize="sm" color="gray.400">—</Text>;
  return (
    <Flex gap={1} wrap="wrap">
      {items.map((item) => (
        <Badge key={`${item.type}-${item.ref}-${item.status}`} colorScheme={outcomeColor(item)} variant="subtle" textTransform="none">
          {outcomeLabel(item, lang)}
        </Badge>
      ))}
    </Flex>
  );
};

// 本通结果 / Call outcome card at the top of a call record, in time order.
const CallOutcomeCard = ({ call, lang = 'zh', callbackPath = null, timezone }) => {
  const zh = lang === 'zh';
  const items = callOutcomes(call);
  return (
    <Card mb={6} data-testid="call-outcome-card">
      <CardHeader pb={2}>
        <Heading size="md">{zh ? '本通结果' : 'Call outcome'}</Heading>
      </CardHeader>
      <CardBody pt={2}>
        {items.length === 0 ? (
          <Text color="gray.600">{zh ? '这通电话没有发短信、建工单、建回电或转接。' : 'No text, ticket, callback or transfer from this call.'}</Text>
        ) : (
          <VStack align="stretch" spacing={3}>
            {items.map((item) => {
              const href = outcomeLink(item, { callbackPath, callRef: call?.session_id || call?.call_id });
              const detail = outcomeDetail(item, lang);
              return (
                <Flex key={`${item.type}-${item.ref}-${item.at}-${item.status}`} gap={3} align="center" wrap="wrap">
                  <Badge colorScheme={outcomeColor(item)} variant="subtle" textTransform="none" fontSize="sm">
                    {outcomeLabel(item, lang)}
                  </Badge>
                  {detail && <Text fontSize="sm" color="gray.600">{detail}</Text>}
                  {item.at && <Text fontSize="sm" color="gray.500">{formatCallTime(item.at, timezone)}</Text>}
                  {href && (
                    <Link as={RouterLink} to={href} fontSize="sm" color="blue.600" textDecoration="underline">
                      {zh ? '查看回电请求' : 'Open callback request'}
                    </Link>
                  )}
                </Flex>
              );
            })}
          </VStack>
        )}
      </CardBody>
    </Card>
  );
};

export default CallOutcomeCard;
